import {BaseUrlConstant} from "@/server/base-url.constant";

const url = {
  OAUTH_TOKEN: `${BaseUrlConstant.BASE_AUTHENTICATION_SERVICE}/oauth/token`,
}

export default url;
